<template>
  <div class="shop-tags-wrapper" v-loading="loading">
    <div class="header-wrapper">
      <h3 class="title">{{shopInfo.name}} / 商品分类管理</h3>
      <div class="btn-group">
        <el-button type="primary" size="small" @click="handleShowTagDialog('new')">添加标签</el-button>
      </div>
    </div>
    <ul class="tags-list">
      <li class="tag-wrapper"
        draggable="true"
        v-for="(tag, index) in tags"
        :key="tag.id"
        @dragstart="handleDrag(index, $event)"
        @dragenter.prevent
        @dragover.prevent
        @drop="handleDrop(index, $event)">
        <span class="name">{{tag.name}}</span>
        <span class="count">商品数量{{tag.product_count}}</span>
        <span class="edit" @click="handleShowTagDialog('edit', tag)">编辑</span>
        <span class="edit" @click="handleDelTag(tag.id)">删除</span>
      </li>
    </ul>
    <el-dialog :title="dialog.title" v-model="dialog.visable" size="tiny">
      <div>
        <el-input v-model="dialog.tagName" placeholder="请输入标签名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.visable = false">取 消</el-button>
        <el-button type="primary" @click="handleTagSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'shop-tags',
  data () {
    return {
      loading: true,
      dialog: {
        title: '添加标签',
        visable: false,
        tagId: null,
        tagName: ''
      }
    }
  },
  computed: {
    shopInfo () {
      return this.$store.getters['shop/shopInfo']
    },
    tags () {
      return this.$store.state.shop.tags || []
    }
  },
  mounted () {
    this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
    this.$store.dispatch('shop/fetchTags').then(() => {
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    handleDrag (index, e) {
      e.dataTransfer.setData('text/plain', index)
    },
    handleDrop (toIndex, e) {
      let fromIndex = Number(e.dataTransfer.getData('text'))
      e.dataTransfer.clearData()
      this.loading = true
      this.$store.dispatch('shop/pushSwitchTag', {indexA: fromIndex, indexB: toIndex})
      .then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleDelTag (tagId) {
      this.$store.dispatch('shop/delTag', tagId)
    },
    handleTagSave () {
      if (this.dialog.tagName === '') {
        this.$notify.warning({
          title: '失败',
          message: '请输入标签名称'
        })
        return
      }
      if (this.dialog.tagId) {
        this.$store.dispatch('shop/updateTag', {tagName: this.dialog.tagName, tagId: this.dialog.tagId}).then(resp => {
          this.dialog.visable = false
        })
      } else {
        this.$store.dispatch('shop/addTag', this.dialog.tagName).then(resp => {
          this.dialog.visable = false
        })
      }
    },
    handleShowTagDialog (type, tag) {
      if (type === 'edit') {
        this.dialog.title = '编辑标签'
        this.dialog.tagName = tag.name
        this.dialog.tagId = tag.id
      }
      if (type === 'new') {
        this.dialog.title = '添加标签'
        this.dialog.tagName = ''
        this.dialog.tagId = null
      }
      this.dialog.visable = true
    }
  }
}
</script>

<style lang="sass">
.shop-tags-wrapper
  padding: 20px;
  min-height: 500px;
  .header-wrapper
    overflow: hidden;
    margin-bottom: 10px;
    .title
      font-size: 14px;
      line-height: 2;
      font-weight: 600;
      float: left;
    .info
      font-size: 12px;
      line-height: 28px;
      float: left;
    .btn-group
      float: right;
  .tags-list
    position: relative;
    .tag-wrapper
      position: relative;
      overflow: hidden;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 0 10px rgba(0,0,0, .15);
      padding: 12px 20px;
      margin-top: 12px
      width: 400px;
      height: 46px;
      box-sizing: border-box;
      cursor: move;
      span
        display: inline-block;
      .name
        font-size: 14px;
        font-weight: 600;
        width: 80px;
      .count
        font-size: 13px;
      .edit
        font-size: 13px;
        color: #00b781;
        width: 50px;
        float: right;
        text-align: right;
        cursor: pointer;
</style>


// WEBPACK FOOTER //
// tags.vue?b1513efa